import React, { FC, ReactElement } from "react";

import { Divider, Grid, Typography } from "@mui/material";

import logo from "../../assets/persistent.gif";

const ChatPlaceholder: FC<any> = (): ReactElement => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      direction="column"
    >
      <img src={logo} alt="PSL Logo" width="300px" height="300px" />
      <Typography
        color="text"
        fontWeight="bold"
        sx={{
          fontSize: "18px",
        }}
      >
        Select a conversation
      </Typography>
      <Divider
        sx={{
          width: "50%",
          my: 2,
        }}
      >
        <Typography
          color="text"
          fontWeight="bold"
          sx={{
            fontSize: "18px",
          }}
        >
          OR
        </Typography>
      </Divider>
      <Typography
        color="text"
        fontWeight="bold"
        sx={{
          fontSize: "18px",
        }}
      >
        Click New Conversation
      </Typography>
    </Grid>
  );
};

export default ChatPlaceholder;
